// Clears any query parameters from the current url.
const clearQueryParams = async () =>
  window !== `undefined` &&
  window.history.replaceState({}, document.title, window.location.pathname);

export default clearQueryParams;
